





































import { Component } from 'vue-property-decorator';
import IssueItemPc from '@/components/ViewComponent/Issue/IssueItem/IssueItemPc.vue';
import IssueDivider from '@/components/ViewComponent/Issue/IssueList/IssueDivider.vue';
import { mapActions } from 'vuex';
import IssueListMixin from './issue-list.mixin';

@Component<IssueListPc>({
  components: { IssueDivider, IssueItemPc },
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
})
export default class IssueListPc extends IssueListMixin {
  fetchCurrentStaff!: () => void;
  get scrollEl(): Window | Element {
    if (this.$refs.container instanceof Element) {
      return this.$refs.container;
    }
    return this.$refs.container.$el;
  }

  async afterFirstFetch(): Promise<any> {
    if (!this.$route.params.id && this.items.length > 0) {
      await this.$router.push(`/issue/${this.items[0].id}`);
    }
  }
  mounted() {
    this.$cheeers.socket.on('notify_issue@new_comment', async (data) => {
      const { id } = this.$route.params;
      this.refreshItem(data.id);
      if (Number(id) === data.id) {
        await this.$http.patch('/notify-issue/isread-notify-issue', {
          issueId: Number(id),
        });
      }
    });
  }
}
